import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea7ae432"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-4 border-0 border-solid border-t border-gray-theme-400 border-opacity-30 relative flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 bg-white bg-opacity-75 flex flex-col justify-center items-center z-1000 gap-3 rounded-md"
}
const _hoisted_3 = { class: "flex flex-col text-center" }
const _hoisted_4 = {
  key: 1,
  class: "px-4 h-11 border-0 border-b border-solid font-medium flex items-center justify-between gap-3"
}
const _hoisted_5 = { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }
const _hoisted_6 = { class: "flex gap-2 flex-shrink-0" }
const _hoisted_7 = {
  key: 2,
  class: "flex w-full h-7 px-4"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  htmlFor: "cc",
  class: "w-16 flex-shrink-0 mt-1"
}, " CC ", -1))
const _hoisted_9 = {
  key: 3,
  class: "flex w-full h-7 px-4"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  htmlFor: "bcc",
  class: "w-16 flex-shrink-0 mt-1"
}, " BCC ", -1))
const _hoisted_11 = { class: "flex mt-4 px-4" }
const _hoisted_12 = { class: "mt-auto mb-4" }
const _hoisted_13 = { class: "mt-auto px-4 flex justify-between items-center" }

import {
	ConversationEmailMessage,
	ConversationTextMessage,
	useConversations
} from '@/inbox/composition';
import { ref, onMounted, reactive } from 'vue';
import {
	UiButton,
	Tooltip,
	SvgIcon,
	UiFileUpload,
	UiLoader,
	BorderedButton,
	useUiState
} from '@/ui-kit';
import ImageFile from '@/phone-numbers/components/ImageFile.vue';
import FileBlock from '@/phone-numbers/components/FileBlock.vue';
import { Contact } from '@/contacts';
import EmailChipsInput from '@/messenger/email/components/EmailChipsInput.vue';
import { useSendEmail } from '@/inbox/compose-input/use-send-email';
import { AxiosError } from 'axios';
import { useToast } from 'vue-toastification';
import { useSendSMS } from '@/inbox/compose-input/use-send-sms';
import Editor from '../../compose-input/Editor.vue';
import { useEmails } from '@/messenger';
import { useMagicKeys, whenever } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReplyInput',
  props: {
    message: null,
    contact: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	message:
		| ConversationEmailMessage
		| ConversationTextMessage;
	contact: Contact;
};





const replyBlockInputRef = ref<HTMLInputElement>();
const buttonRef = ref<HTMLButtonElement>();

const { sendReply } = useSendEmail();
const { selectedConversation } = useConversations();
const {
	ctrl_shift_c,
	ctrl_shift_b,
	cmd_enter,
	ctrl_enter
} = useMagicKeys();
const ui = useUiState();

whenever(
	() => cmd_enter.value && ui.isNoDialogAndDropdown,
	() => {
		sendMessage();
	}
);

whenever(
	() => ctrl_enter.value && ui.isNoDialogAndDropdown,
	() => {
		sendMessage();
	}
);

whenever(
	() => ctrl_shift_c.value && ui.isNoDialogAndDropdown,
	() => {
		emailExtra.hasCC = !emailExtra.hasCC;
	}
);

whenever(
	() => ctrl_shift_b.value && ui.isNoDialogAndDropdown,
	() => {
		emailExtra.hasBCC = !emailExtra.hasBCC;
	}
);

onMounted(() => {
	replyBlockInputRef.value?.focus();
	setTimeout(() => {
		buttonRef.value?.scrollIntoView({
			block: 'center'
		});
	});
});

const files = ref<File[]>([]);

function setFiles(newFiles: File[]) {
	files.value = [...files.value, ...newFiles];
}

function removeFile(i: number) {
	files.value = files.value.filter(
		(item, idx) => i !== idx
	);
}

const text = ref('');

const status = ref<
	'none' | 'sendingMessage' | 'error' | 'success'
>('none');
const error = ref('');
const { success } = useToast();
const { emails } = useEmails();

function fromEmail(email: string) {
	return emails.value.find(
		(a) => a.hash === email || a.email === email
	);
}

async function sendMessage() {
	if (!text.value) {
		error.value = 'Enter you reply';
		return;
	}

	const isInbound =
		props.message.content.direction === 'incoming';

	const from = fromEmail(
		isInbound ? props.message.to : props.message.from
	)?.email;

	if (!from) {
		return;
	}

	const to = isInbound
		? props.message.from
		: props.message.to;
	error.value = '';
	status.value = 'sendingMessage';
	try {
		await sendReply(
			selectedConversation.value!.id,
			props.message.uid,
			{
				to,
				from,
				files: files.value,
				body: text.value,
				extra: {
					subject: `Re: ${
						(props.message.content as any)
							.subject ||
						(props.message as any).subject
					}`
				},
				...(emailExtra.hasBCC &&
				emailExtra.bcc.length
					? { bcc: emailExtra.bcc.join(', ') }
					: {}),
				...(emailExtra.hasCC && emailExtra.cc.length
					? { cc: emailExtra.cc.join(', ') }
					: {})
			}
		);
		status.value = 'success';
		success(`Reply sent`, {
			position: 'bottom-right' as any
		});
		emit('close');
	} catch (err) {
		const response = (err as AxiosError)?.response;
		status.value = 'error';
		error.value =
			response?.data?.message ||
			(err as AxiosError).message;
	}
}

const emailExtra = reactive({
	hasCC: false,
	hasBCC: false,
	cc: [],
	bcc: []
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (status.value === 'sendingMessage')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, " Sending reply to " + _toDisplayString(__props.contact?.name), 1)
          ]),
          _createVNode(_unref(UiLoader))
        ]))
      : _createCommentVNode("", true),
    (__props.message.type === 'email')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, "Re: " + _toDisplayString(__props.message.content.subject), 1),
          _createElementVNode("div", _hoisted_6, [
            (!emailExtra.hasCC)
              ? (_openBlock(), _createBlock(_unref(BorderedButton), {
                  key: 0,
                  class: "w-10",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emailExtra.hasCC = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("CC")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!emailExtra.hasBCC)
              ? (_openBlock(), _createBlock(_unref(BorderedButton), {
                  key: 1,
                  class: "w-10",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emailExtra.hasBCC = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("BCC")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (emailExtra.hasCC)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(EmailChipsInput, {
            loading: false,
            modelValue: emailExtra.cc,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((emailExtra.cc) = $event)),
            placeholder: "Enter CC email",
            class: "!py-0 w-full text-gray-theme-500",
            name: "cc"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (emailExtra.hasBCC)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(EmailChipsInput, {
            loading: false,
            modelValue: emailExtra.bcc,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((emailExtra.bcc) = $event)),
            placeholder: "Enter BCC email",
            class: "!py-0 w-full text-gray-theme-500",
            name: "bcc"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Tooltip), {
      theme: "danger",
      showTriggers: [],
      hideTriggers: [],
      placement: "top-start",
      delay: {
				show: 0,
				hide: 0
			},
      shown: !!error.value && !text.value
    }, {
      popper: _withCtx(() => [
        _createTextVNode(_toDisplayString(error.value), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(Editor, {
          modelValue: text.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((text).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["shown"]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "mx-1 mt-2",
          key: i
        }, [
          (file.type.includes('image'))
            ? (_openBlock(), _createBlock(ImageFile, {
                key: 0,
                isLarge: "",
                onRemove: ($event: any) => (removeFile(i)),
                file: file
              }, null, 8, ["onRemove", "file"]))
            : (_openBlock(), _createBlock(FileBlock, {
                key: 1,
                isLarge: "",
                onRemove: ($event: any) => (removeFile(i)),
                file: file
              }, null, 8, ["onRemove", "file"]))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_unref(Tooltip), { placement: "right" }, {
          popper: _withCtx(() => [
            _createTextVNode(" Attach file ")
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(UiFileUpload), {
              accept: '*',
              multiple: "",
              modelValue: files.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (
							setFiles($event)
						))
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  ref_key: "buttonRef",
                  ref: buttonRef,
                  class: "cursor-pointer"
                }, [
                  _createVNode(_unref(SvgIcon), {
                    name: "AttachIcon",
                    class: "h-4 w-4"
                  })
                ], 512)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), { placement: "left" }, {
          popper: _withCtx(() => [
            _createTextVNode(" Send " + _toDisplayString(__props.message.type === 'email'
								? 'email'
								: 'sms'), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(UiButton), {
              class: "!text-sm !h-8 !min-w-20 !px-0",
              theme: "primary-outlined",
              disabled: 
							status.value === 'sendingMessage'
						,
              onClick: sendMessage
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Send ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})